import { render } from "./FavoHeart.vue?vue&type=template&id=74a1d4de"
import script from "./FavoHeart.vue?vue&type=script&lang=js"
export * from "./FavoHeart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__